import styled from '@emotion/styled'

// 提示框的title标题样式
const StyledTitle = styled.div`
  padding: 5px 12px;
  width: 100%;
  display: inline-block;
  /* border:1px solid blue; */
  /* display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center; */
  color: ${(props) => {
    const { type, theme = {} } = props
    const { colors = {} } = theme
    if (type === 'success' && colors.success && colors.success[900]) {
      return colors.success[900]
    }
    if (type === 'error' && colors.danger && colors.danger[900]) {
      return colors.danger[900]
    }
    if (type === 'warning' && colors.waring && colors.waring[900]) {
      return colors.waring[900]
    }
    if (type === 'info' && colors.info && colors.info[900]) {
      return colors.info[900]
    }
    return (colors.info && colors.info[900]) || '#6c757d'
  }};
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`

export default StyledTitle
